import type { RouteLocationNamedRaw } from 'vue-router'
import MailboxTypes from '@/assets/enums/notifications/mailboxTypes'

interface MailNotificationParams {
  group_id?: string | null
  model_notification_id?: string | null
  direction?: string | null
}

/**
 * Builds the route opening the mail thread targeted by a mail notification,
 * focused on the exact message. Rejected outgoing mails open in the sent box.
 */
export function buildMailNotificationRoute(
  params: MailNotificationParams | null | undefined
): RouteLocationNamedRaw | null {
  const groupId = params?.group_id
  if (!groupId) {
    return null
  }

  return {
    name: 'mail_box_page_group_id',
    params: {
      path:
        params.direction === 'outgoing'
          ? MailboxTypes.SENT
          : MailboxTypes.INBOX,
      groupId
    },
    ...(params.model_notification_id && {
      query: { message: params.model_notification_id }
    })
  }
}
